import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function HeroSection() {
  const topArticles = articles.filter(a => a.isTop).slice(0, 3);

  return (
    <section className="relative w-full min-h-[520px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20atmospheric%20newsroom%20background%20with%20abstract%20geometric%20shapes%2C%20deep%20crimson%20and%20charcoal%20color%20palette%2C%20modern%20minimalist%20design%2C%20subtle%20gradient%20overlay%2C%20editorial%20news%20media%20aesthetic%2C%20soft%20diffused%20lighting%2C%20no%20text&width=1920&height=1080&seq=hero-bg-51&orientation=landscape"
          alt="51黑料网背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="text-center mb-10">
          <h1 className="font-heading text-3xl md:text-5xl font-bold text-white mb-3">
            51黑料网
          </h1>
          <p className="text-base md:text-lg text-white/80">
            今日黑料最新 · 黑料每日更新 · 快速获取新鲜黑料内容
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {topArticles.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className={`group relative rounded-xl overflow-hidden cursor-pointer ${
                index === 0 ? "md:col-span-2 md:row-span-2" : ""
              }`}
            >
              <div className={`${index === 0 ? "aspect-[16/9] md:aspect-auto md:h-full" : "aspect-[16/9]"} bg-background-800 overflow-hidden`}>
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  title={article.title}
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6">
                <span className="inline-block px-2 py-0.5 rounded-full text-xs bg-primary-500 text-white mb-2">
                  {article.categoryName}
                </span>
                <h2 className={`font-heading font-bold text-white group-hover:text-primary-300 transition-colors duration-200 line-clamp-2 ${
                  index === 0 ? "text-lg md:text-2xl" : "text-sm md:text-base"
                }`}>
                  {article.title}
                </h2>
                <p className={`mt-2 text-white/70 line-clamp-2 ${index === 0 ? "text-sm" : "text-xs"}`}>
                  {article.summary}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}